import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=60004e8a&"
import script from "./PromotionEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=60004e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports